export const rootPaths = {
  registrationRoot: '/registration',
  errorsRoot: '/errors',
  authRoot: '/authentication',
  dashboardRoot: '/dashboards',
  ticketsRoot: '/tickets',
  userRoot: '/user',
  companyRoot: '/company',
  reports: '/reports',
  settings: '/settings',
  integrations: '/integrations',
  assets: '/assets',
  alerts: '/alerts',
  documents: '/documents',
  finance: '/finance'
};

export default {
  starter: '/',
  landing: '/landing',
  login: '/login',
  authorized: '/authorized',
  resetPassword: 'reset-password',
  createPassword: '/create-password',
  inviteUser: '/invite',
  error403: `${rootPaths.errorsRoot}/403`,
  error404: `${rootPaths.errorsRoot}/404`,
  error500: `${rootPaths.errorsRoot}/500`,
  error403: `${rootPaths.errorsRoot}/access-denied`,
  settings: `${rootPaths.settings}`,
  emailNotifications: `${rootPaths.settings}/email-notifications`,
  editEmailNotification: `${rootPaths.settings}/email-notifications/:id/edit`,
  dashTickets: `${rootPaths.dashboardRoot}/tickets`,
  listTickets: `${rootPaths.ticketsRoot}`,
  ticketsPreview: `${rootPaths.ticketsRoot}/:id`,
  listPreTickets: `/pre-tickets`,

  // Rotas alteradas para settings
  agentRegistration: `${rootPaths.settings}/agents`,
  agentCreate: `${rootPaths.settings}/agents/new`,
  agentEdit: `${rootPaths.settings}/agents/:id/edit`,
  serviceGroupRegistration: `${rootPaths.settings}/service-groups`,
  profileRegistration: `${rootPaths.settings}/profiles`,
  profileEdit: `${rootPaths.settings}/profiles/:id/edit`,
  serviceCatalogRegistration: `${rootPaths.settings}/services-catalog`,
  serviceCatalogDetails: `${rootPaths.settings}/services-catalog/:id`,
  typeTicketRegistration: `${rootPaths.settings}/types-ticket`,
  slaPolicyList: `${rootPaths.settings}/sla-policies`,
  slaPolicyEdit: `${rootPaths.settings}/sla-policies/:id`,
  businessHourRegistration: `${rootPaths.settings}/business-hour`,
  pauseReasonRegistration: `${rootPaths.settings}/pause-reasons`,
  scheduledTicketList: `${rootPaths.settings}/scheduleds-tickets`,
  scheduledTicketRegistration: `${rootPaths.settings}/scheduleds-tickets/new`,
  scheduledTicketCloneRegistration: `${rootPaths.settings}/scheduleds-tickets/clone/:id`,
  scheduledTicketEdit: `${rootPaths.settings}/scheduleds-tickets/:id`,
  assetTypeRegistration: `${rootPaths.settings}/asset-types`,
  assetTypeEdit: `${rootPaths.settings}/asset-types/:id`,
  emailBoxRegistration: `${rootPaths.settings}/mailbox`,
  holidayRegistration: `${rootPaths.settings}/holidays`,
  tagsRegistration: `${rootPaths.settings}/tags`,
  apiKeysRegistration: `${rootPaths.settings}/api-keys`,
  taskTemplateRegistration: `${rootPaths.settings}/task-templates`,
  taskTemplateNew: `${rootPaths.settings}/task-templates/new`,
  taskTemplateEdit: `${rootPaths.settings}/task-templates/:id`,
  taskTemplateClone: `${rootPaths.settings}/task-templates/:id/clone`,
  catalogItems: `${rootPaths.settings}/catalog-items`,
  messageTemplates: `${rootPaths.settings}/message-templates`,

  // Rotas mantidas em registration
  customerRegistration: `${rootPaths.registrationRoot}/customers`,
  customerDetails: `${rootPaths.registrationRoot}/customers/:id`,
  contactRegistration: `${rootPaths.registrationRoot}/contacts`,

  // Rotas para solutions
  solutions: `${rootPaths.documents}`,
  articleSearch: `${rootPaths.documents}/article-search`,
  articleRegistration: `${rootPaths.documents}/articles/new`,
  articleEdit: `${rootPaths.documents}/articles/:id/edit`,
  articlePreview: `${rootPaths.documents}/articles/:id`,

  profileUser: `${rootPaths.userRoot}/profile`,
  myCompany: `${rootPaths.companyRoot}/my-company`,
  reportExecutiveCustomer: `${rootPaths.reports}/executive`,
  productivityAnalysis: `${rootPaths.reports}/productivity-analysis`,
  reportOverview: `${rootPaths.reports}/overview`,

  // Custom Reports
  customReportList: `${rootPaths.reports}/custom`,
  customReportNew: `${rootPaths.reports}/custom/new`,
  customReportEdit: `${rootPaths.reports}/custom/:uuid/edit`,
  customReportDetails: `${rootPaths.reports}/custom/:uuid`,
  customReportExecution: `${rootPaths.reports}/custom/:uuid/view`,
  integrations: `${rootPaths.settings}/integrations`,
  dattoRMM: `${rootPaths.integrations}/datto-rmm`,
  mspTalks: `${rootPaths.integrations}/msptalks`,
  assetList: `${rootPaths.assets}`,
  assetRegistration: `${rootPaths.assets}/new`,
  assetDetails: `${rootPaths.assets}/:id`,
  assetEdit: `${rootPaths.assets}/:id/edit`,
  alertList: `${rootPaths.alerts}`,
  billing: `${rootPaths.finance}/billing`,
  billingDetail: `${rootPaths.finance}/billing/:code`,

  // Rotas para busca global
  searchResults: '/search-results'
};
